import React from "react";
import "./ChartCard.css";

interface ChartCardProps {
  title: string;
  /** Optional right-aligned header slot (e.g. a legend). */
  headerRight?: React.ReactNode;
  /** The chart canvas (or a skeleton) — goes in the fixed-height canvas area. */
  children: React.ReactNode;
}

/**
 * Shared card shell for the dashboard charts: the raised card, a title header
 * (with an optional right slot), and a fixed-height canvas area. Used by both
 * {@link LineChartCard} and {@link SourceBarCard} so the card chrome lives with
 * one component instead of in a chart-agnostic stylesheet.
 */
export const ChartCard: React.FC<ChartCardProps> = ({ title, headerRight, children }) => (
  <div className="chart-card">
    <div className="chart-card-head">
      <span className="chart-card-title">{title}</span>
      {headerRight}
    </div>
    <div className="chart-canvas-wrap">{children}</div>
  </div>
);
